var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{ name: 'guest-login' }}},[_vm._v("Back to guest login screen")]),_c('hr')],1)}
var staticRenderFns = []

export { render, staticRenderFns }